// tslint:disable
export enum PharmacyJobType {
    /**
     * @description Triage to Pharmacy Inbound Feed
     */
    T2PInboundFeed = 1,
}
(PharmacyJobType as any)['T2PINBOUNDFEED'] = 1;
